module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Nombre de usuario":"Nombre de usuario","Contraseña":"Contraseña","Registro":"Registro","Restablecer contraseña":"Restablecer contraseña"},"en":{},"ca":{"Nombre de usuario":"Nom d\u0027usuari","Contraseña":"Contrasenya","Registro":"Registre","Restablecer contraseña":"Restablir contrasenya"}}')
  delete Component.options._Ctor
}
